import { CHALLENGE_LIST_ACTION } from 'core/constants/Actions'
import { Action } from 'core/models/ActionTypes'
import { Challenge } from 'core/models/Challenge'

const initialState: { challenges: Challenge[], count: number, currentPage: number, isLoading: boolean } = {
  challenges: [],
  isLoading: false,
  count: 0,
  currentPage: 0
}

interface ActionType extends Action {
  payload: {
    challenges: Challenge[];
    count: number;
    currentPage: number;
  }
}

export default function challengeListReducer(state = initialState, action: ActionType) {

  switch (action.type) {
    case CHALLENGE_LIST_ACTION.REQUEST:
      return { ...state, isLoading: true }

    case CHALLENGE_LIST_ACTION.SUCCESS:
      const { challenges, count, currentPage } = action.payload;
      return { ...state, challenges, count, currentPage, isLoading: false }

    case CHALLENGE_LIST_ACTION.FAILURE:
      return { ...state, ...initialState }

    default:
      return state
  }
}